// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"392d49fa","239":"f3a43611","453":"32433842","732":"1a088d20"}[chunkId] + ".chunk.js";
};